import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { SERVICEURL } from "../../appconfig";

/** API positionDifficultyInfo elemanı */
export interface PositionDifficultyInfoItem {
  id: string;
  positionId: string;
  difficultyId: string;
  difficultyName: string;
  difficultyLvlId?: string | null;
  difficultyLvlName: string;
}

/** GetPositionDifficulties API data objesi */
export interface PositionDifficultiesData {
  id: string;
  positionId: string;
  positionDifficultyInfo: PositionDifficultyInfoItem[];
  positionPoint: number;
}

interface GetPositionDifficultiesResponse {
  code?: number;
  message?: string;
  data?: PositionDifficultiesData;
}

export const useGetPositionDifficulties = (positionId?: string | number) => {
  const [data, setData] = useState<PositionDifficultiesData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    if (!positionId) {
      setData(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      const response = await axios.get<GetPositionDifficultiesResponse>(
        `${SERVICEURL}api/Position/GetPositionDifficulties/${positionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const payload = response.data?.data ?? null;
      setData(payload);
    } catch (err: any) {
      setError(err instanceof Error ? err : new Error(err?.message || "Unknown error"));
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [positionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
